export enum BillingStatus {
	Trial = 'trialing',
	TrialExpired = 'trialing_expired',
	Active = 'active',
	Inactive = 'inactive',
}

export interface IPriceInterval {
	type: string;
	qty: number;
}

export interface IPrice {
	id: string;
	amount: number;
	currency: string;
	interval: IPriceInterval;
	default?: boolean;
}

export interface IPlan {
	_id: string;
	planId: string;
	prices: IPrice[];
	name: string;
	description: string;
	trialDays: number;
	level: number;
	features: string[];
	hidden: boolean;
}

export interface ISubscription {
	subscriptionId: string;
	isFreeTrial: boolean;
	isFreeTrialExpired: boolean;
	freeTrialEnd: string;
	plan: {
		id: string;
		amount: number;
		interval: string;
		currency: string;
		product: string;
		level: number;
	};
	nextBillingDate: string;
	paymentMethod: any | null;
	billingStatus: BillingStatus;
	checkoutUrl?: string;
	startDate: string;
}

export interface ICreditCheckResponse {
	hasEnoughCredits: boolean;
	amountRequired?: number;
	checkoutUrl?: string;
	errorType?: 'CAMPAIGN_LIMIT_REACHED';
	errorMessage?: string;
	currentCount?: number;
	limit?: number;
	provider?: 'appsumo' | 'stripe';
	planName?: string;
	canUpgrade?: boolean;
	upgradePrice?: number;
	upgradeCurrency?: string;
	nextPlanId?: string;
}
